<!-- P6:1535-1538 -->
<span class="cx-ring" [style.width.px]="Size" [style.height.px]="Size">
  <svg [attr.width]="Size" [attr.height]="Size" [attr.viewBox]="'0 0 ' + Size + ' ' + Size" aria-hidden="true">
    <circle class="trk" [class.mini]="Size === 18" [attr.cx]="Size / 2" [attr.cy]="Size / 2" [attr.r]="Geometry.R" fill="none" [attr.stroke-width]="Geometry.Stroke"/>
    <circle class="fil" [class.done]="Complete" [attr.cx]="Size / 2" [attr.cy]="Size / 2" [attr.r]="Geometry.R" fill="none" [attr.stroke-width]="Geometry.Stroke"
        stroke-linecap="round" [attr.stroke-dasharray]="Geometry.Dash + ' ' + Geometry.Circumference"/>
  </svg>
  @if (ShowLabel) { <b>{{ Label }}</b> }
</span>
